import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { Subscription } from 'rxjs';

import { ToastMessageOptions } from 'primeng/api';
import { MessageService, countSymbol } from '../../services/message-service';
import { AuthService } from '../../authentication/auth.service';
import { ToastPositionType } from 'primeng/toast';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    standalone: false
})
export class ToastComponent implements OnInit, OnDestroy {
    @Input() position: ToastPositionType = 'top-right';
    @Input() hideOnClick: boolean = false;
    authMessage: { summary: string, detail: string} = null;

    subscriptions: Subscription[];

    readonly countSymbol = countSymbol;

    constructor(
        private authService: AuthService,
        private messageService: MessageService) {
    }

    ngOnInit(): void {
        this.subscriptions = [
            this.authService.AuthMessage.subscribe(msg => {
                setTimeout(() => { this.authMessage = msg; });
            })
        ];
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => { s.unsubscribe(); });
    }

    onCloseMessage(event: { message: ToastMessageOptions }): void {
        this.messageService.removeMessage(event.message);
    }
}
